import React from 'react'
import { Page, Document, StyleSheet,    Text,View, Font, Image } from '@react-pdf/renderer';
import { HoraActual, calcularEdad, fechaActual } from '../../../hooks/UseDate';
import logo from '../../../images/Logo-G-Ocho.png'

// Registro de fuente personalizada
Font.register({
  family: 'Open Sans',
  fonts: [
    { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf' },
    { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf', fontWeight: 600 }
  ]
})

const styles = StyleSheet.create({
    table: { 
      display: "table", 
      width: "auto", 
      borderStyle: "none", 
      //borderWidth: 1, 
      //borderRightWidth: 0, 
      // borderBottomWidth: 0 
    }, 
    tableRow: { 
      //margin: "auto", 
      flexDirection: "row" 
    }, 
    // tableCol: { 
    //   width: "16.6%", 
    //   borderStyle: "none", 
    //   //borderWidth: 1, 
    //   //borderLeftWidth: 0, 
    //   //borderTopWidth: 0 
    // }, 
    tableCell: { 
      width: "10%",
      padding: '3px',
      //flexGrow: 1,
      //margin: "auto", 
      //marginTop: 2, 
      fontSize: 7 
    },
    // body:{
    //   padding: '10px'
    // },
    tableCellLarge:{
      width: "50%",
      padding: '3px',
      //flexGrow: 1,
      //margin: "auto", 
      //marginTop: 2, 
      fontSize: 7 
    },
    left: {
      flex: 1,
      textAlign: 'left',
      fontSize: 9
    },
    right: {
      flex: 1,
      textAlign: 'right',
      fontSize: 9
    },    
    textBlock: {
      marginBottom: 10,
    },
    bold:{
      fontFamily: 'Open Sans',
      fontWeight: 600
    },
    image: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: 60, 
      height: 60, 
      margin: '10px',
    },
  });

const PDFReimprimirHojaDeGasto = ({dataSuministros,dataUser,informacionEmpresa}) => {
    
  return (
    <Document>
        <Page size='A4' style={{padding: '30px' }}>
            {/* <View>
                <Text style={{ fontSize: 10,textAlign: 'center',padding: '5px'}}>{informacionEmpresa.EmpRazSoc}</Text>            
                <Text style={{ fontSize: 10,textAlign: 'center',padding: '5px'}}>{informacionEmpresa.EmpNit}</Text>
                <Text style={{ fontSize: 10,textAlign: 'center',padding: '5px'}}>DESPACHOS DE PRODUCTOS</Text>
                <Text style={{ fontSize: 8,padding: '2px'}}>Fecha: {fechaActual()}</Text>
                <Text style={{ fontSize: 8}}>Hora: {HoraActual()}</Text>
                <Text style={{ fontSize: 8,padding: '2px'}}>PACIENTE {dataUserPDF? dataUserPDF.HISTipDoc:null} {dataUserPDF? dataUserPDF.HISCKEY:null} {dataUserPDF? dataUserPDF.MPNOMC.trim():null}        SEXO {dataUserPDF? dataUserPDF.MPSexo:null}      Edad:{dataUserPDF? calcularEdad(dataUserPDF.MPFchN.split(" ")[0]):null} Años</Text>
                <Text style={{ fontSize: 8,padding: '2px'}}>PABELLON {dataUserPDF? dataUserPDF.TFcNomPab.trim():null} {dataUserPDF? dataUserPDF.TFcCodCam:null} Folio:{dataUserPDF?dataUserPDF.HISCSEC:null} </Text>
                <Text style={{ fontSize: 8,padding: '2px'}}>SERVICIO {dataUserPDF? (dataUserPDF.ClaPro === '1'? 'Ambulatorio':(dataUserPDF.ClaPro === '2'? 'Hospitalización':(dataUserPDF.ClaPro === '3'? 'Urgencias':(dataUserPDF.ClaPro === '4'? 'Tratamiento especial':(dataUserPDF.ClaPro === '5'? 'Triage':(dataUserPDF.ClaPro === '6'? 'Refacturacion ambulatoria':(dataUserPDF.ClaPro === '7'?'Refactorizacion hospitalizacion':(dataUserPDF.ClaPro === '8'? 'Refactorizacion urgencias':null)))))))):null} EMPRESA: {dataUserPDF? dataUserPDF.TFNomCto:null}</Text>
                <Text style={{marginTop: 2, borderTop: '1pt solid #000', marginTop: 4, padding: '5px'}}/>
            </View> */}
            <View>
            <Image style={styles.image} src={logo} />
                <Text style={{ fontSize: 10,textAlign: 'center',padding: '5px',fontFamily: 'Open Sans',fontWeight: 900}}>{informacionEmpresa.EmpRazSoc}</Text>   
                <Text style={{ fontSize: 10,textAlign: 'center',padding: '5px',fontFamily: 'Open Sans',fontWeight: 900}}>{informacionEmpresa.EmpNit}</Text> 
                <Text style={{ fontSize: 10,textAlign: 'center',padding: '5px',fontFamily: 'Open Sans',fontWeight: 900}}>HOJA DE GASTO</Text> 
                <Text style={{ fontSize: 8,padding: '2px'}}><Text style={styles.bold}>Fecha:</Text> {fechaActual()}                                     <Text style={styles.bold}>Hora:</Text> {HoraActual()}</Text>
                {/* <Text style={{ fontSize: 8,padding: '2px'}}></Text>  */}
                <Text style={{ fontSize: 8,padding: '2px'}}><Text style={styles.bold}>Nombre:</Text> {dataUser.MPNOMC? dataUser.MPNOMC.trim():null}                  {dataUser.MPTDoc}-{dataUser.MPCedu}</Text>
                {/* <Text style={{ fontSize: 8,padding: '2px'}}>Numero Documento: {dataUser.MPCedu}</Text> */}
                {/* <Text style={{ fontSize: 8,padding: '2px'}}>Tipo Documento: {dataUser.MPTDoc}</Text> */}
                <Text style={{ fontSize: 8,padding: '2px'}}><Text style={styles.bold}>Edad:</Text> {dataUser.MPFchN? calcularEdad(dataUser.MPFchN.split(" ")[0]) + " Años":null }</Text>
                <Text style={{ fontSize: 8,padding: '2px'}}><Text style={styles.bold}>Paquete:</Text> {dataUser.PaqCod} - {dataUser.PaqDes}</Text>
                <Text style={{ fontSize: 8,padding: '2px'}}><Text style={styles.bold}>Fecha Cirugia Inicio:</Text> {dataUser.ProFec? dataUser.ProFec.split(" ")[0]:null}   {dataUser.ProHorI}                      <Text style={styles.bold}>Fecha Cirugia Final:</Text>{dataUser.ProFecF? dataUser.ProFecF.split(" ")[0]:null}   {dataUser.ProHorF} </Text>
            </View>
            <Text style={{borderBottomWidth: 1, borderBottomColor: 'black',  marginBottom: 5, }}/>
            <View  style={styles.table}>
                <View style={styles.tableRow}>
                    <View style={styles.tableCell}>
                        <Text >Codigo</Text> 
                    </View>
                    <View style={styles.tableCellLarge}> 
                        <Text >Descripción</Text> 
                  </View> 
                  <View style={styles.tableCell}> 
                    <Text >Cantidad Ordenada</Text> 
                  </View> 
                  <View style={styles.tableCell}> 
                    <Text >Cantidad Despachada</Text> 
                  </View> 
                  <View style={styles.tableCell}> 
                    <Text >Cantidad Utilizada</Text> 
                  </View>                  
                  <View style={styles.tableCell}> 
                    <Text >Aplicado</Text> 
                  </View> 
                  <View style={styles.tableCell}> 
                    <Text >Fecha Hora Aplicado</Text> 
                  </View> 
                  <View style={styles.tableCell}> 
                    <Text >Usuario Aplicada</Text> 
                  </View>
                </View>
                {
                    dataSuministros.map((item,index)=>(
                        <View style={styles.tableRow} key={index}>
                            <View style={styles.tableCell}> 
                                <Text >{item.MSRESO}</Text> 
                            </View> 
                            <View style={styles.tableCellLarge}> 
                                <Text >{item.MSNomG? item.MSNomG.trim():null}</Text> 
                                
                            </View> 
                            <View style={styles.tableCell}> 
                                <Text >{item.PQCaSuSl}</Text> 
                            </View> 
                            <View style={styles.tableCell}> 
                                <Text >{item.PQCaSuDs}</Text> 
                            </View> 
                            <View style={styles.tableCell}> 
                                <Text >{item.PQCaSuUs}</Text> 
                            </View> 
                            <View style={styles.tableCell}> 
                                <Text >{item.PQAplSum == 'S'? 'Si': 'No'}</Text> 
                            </View>                             
                            <View style={styles.tableCell}> 
                                <Text >{item.PQAplSum == 'S'? item.PQAplFHor: null}</Text> 
                            </View>
                            <View style={styles.tableCell}> 
                                <Text >{item.PQAplUsu}</Text> 
                            </View>
                        </View>
                    ))
                }
            </View>
              {/* <View>
                <View style={styles.left}>
                  <Text style={{borderBottomWidth: 1, borderBottomColor: 'black',  marginBottom: 5, }}/>
                  <Text style={styles.textBlock}>Quien Entrega</Text>
                  <Text>CC</Text>
                </View>
                <View style={styles.right}>
                  <Text style={{borderBottomWidth: 1, borderBottomColor: 'black',  marginBottom: 5, }}/>
                  <Text style={styles.textBlock}>Quien Recibe</Text>
                  <Text>CC</Text>
                </View>
                
              
            </View> */}
            <View>
            <Text style={{borderBottomWidth: 1, borderBottomColor: 'black',  marginBottom: 5, }}/>
              <Text style={{ fontSize: 10,textAlign: 'center',padding: '5px',marginBottom: 20}}>***  FIN DEL REPORTE  ***</Text>
            </View>
        </Page>
    </Document>
  )
}

export default PDFReimprimirHojaDeGasto